export enum AdminView {
    DEVICES,
    ORDERS
}